/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Request to update an AI Agent session state
*/
export class UpdateSessionRequest {
  /**
  * The state changes to apply to the session
  */
  'stateDelta': { [key: string]: any; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "stateDelta",
      "baseName": "state_delta",
      "type": "{ [key: string]: any; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateSessionRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

